'use client'

import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import { PRODUCT_PLACEHOLDER_IMAGE as PLACEHOLDER_IMAGE } from '@/constants/catalog'
import type { IProductSearchResult } from '@/schemas/catalog/product'

interface IProductCardSearchProps {
    /** Resultado da busca (`product/search`): o Navbar e a busca da listagem usam os mesmos campos. */
    data: Pick<IProductSearchResult, 'name' | 'slug' | 'shortDescription' | 'thumbnailUrl'>
    /** Fecha a lista de resultados ao escolher o produto. */
    clear: () => void
}

/** Linha de resultado da busca de produtos (Navbar e busca da listagem), com link para a PDP. */
const ProductCardSearch: React.FC<IProductCardSearchProps> = ({ data, clear }) => {
    return (
        <Link
            href={`/produtos/${data.slug}`}
            className="flex flex-row  items-center justify-start gap-3 p-2 cursor-pointer hover:bg-secondary-40 rounded-xl"
            onClick={clear}
        >
            <div className="border-0 border-gray-300 cursor-pointer slide-thumb max-md:min-w-[50px] max-md:min-h-[50px]">
                <Image src={data.thumbnailUrl || PLACEHOLDER_IMAGE} alt={data.name} width={150} height={150} />
            </div>
            <div>
                <h3>{data.name}</h3>
                <p>{data.shortDescription}</p>
            </div>
        </Link>
    )
}

export default ProductCardSearch
